import { toaster } from '@optiaxiom/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import { CompanionRule, UpdateRuleRequest } from '@frontend/types';

export function useAppCompanionRuleUpdate(
  agentId: string,
  ruleId: string | undefined,
  onSuccess?: () => void
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (rule: UpdateRuleRequest) => {
      return (
        await http.patch<CompanionRule>(
          `${OPAL_URL}/app-companion/agents/${agentId}/rules/${ruleId}`,
          rule
        )
      ).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['opal:app-companion', 'rules', agentId],
      });
      toaster.create('Rule updated successfully', { type: 'success' });
      onSuccess?.();
    },
    onError: () => {
      toaster.create('Failed to update rule', { type: 'danger' });
    },
  });
}
